/**
 * 隣接する.bggle_one-product要素をグループ化してdivで囲む
 */
document.addEventListener('DOMContentLoaded', function () {
    // .bggle_one-product の全要素を取得
    var products = document.querySelectorAll('.bggle_one-product');

    if (products.length === 0) {
        return;
    }

    var currentGroup = [];

    products.forEach(function (product, index) {
        // 現在の要素を現在のグループに追加
        currentGroup.push(product);

        // 次の要素が存在するかチェック
        var nextProduct = products[index + 1];

        // 次の要素が存在しない、または隣接していない場合、グループを処理
        if (!nextProduct || !isAdjacent(product, nextProduct)) {
            // グループに2つ以上の要素が存在する場合のみラッピング
            if (currentGroup.length > 1) {
                wrapProducts(currentGroup);
            }
            // 新しいグループを開始
            currentGroup = [];
        }
    });

    /**
     * 2つの要素が隣接しているかチェック
     * 同じ親要素を持ち、間に他の要素がないことを確認
     */
    function isAdjacent(elem1, elem2) {
        // 同じ親要素を持つかチェック
        if (elem1.parentNode !== elem2.parentNode) {
            return false;
        }

        // elem1の次のsibling要素を探索
        var nextSibling = elem1.nextSibling;

        while (nextSibling) {
            // テキストノードや空白ノードをスキップ
            if (nextSibling.nodeType === 1) { // Element node
                // 次の要素がelem2の場合、隣接している
                return nextSibling === elem2;
            }
            nextSibling = nextSibling.nextSibling;
        }

        return false;
    }

    /**
     * 要素のグループをdivで囲む
     */
    function wrapProducts(products) {
        if (products.length === 0) {
            return;
        }

        // ラッパーdivを作成
        var wrapper = document.createElement('div');
        wrapper.className = 'bggle_one-products-column-wrapper';

        // 最初の要素の前にラッパーを挿入
        var firstProduct = products[0];
        firstProduct.parentNode.insertBefore(wrapper, firstProduct);

        // すべての要素をラッパー内に移動
        products.forEach(function (product) {
            wrapper.appendChild(product);
        });
    }
});
